<template>
    <div>

        <div class="reper-title mt-2 mb-1" @click="category.visible = !category.visible">
            {{ category.name }}
            <b-icon-arrow-right v-if="!category.visible"></b-icon-arrow-right>
            <b-icon-arrow-down v-else></b-icon-arrow-down>
        </div>
        <b-collapse id="collapse-1" v-model="category.visible" class="mt-2">
            <ul v-show="category.spendings && category.spendings.length" class="flex-repers">
                <li v-for="(spending, key) in category.spendings" :key="key" class="personal-reper col-lg-6 col-md-12" @click="$emit('addProduct', spending.id)">
                    <div class="flex-reper">
                        <div class="reper-info">
                            <div class="reper-label" :class="getClassBySpending(spending)"></div>
                            <p :id="'title'+key" class="mb-0">{{ spending.title.substring(0, 25) }} <span v-if="spending.title.length > 25">...</span></p>
                            <b-tooltip v-if="spending.title.length > 25" :target="'title'+key">{{ spending.title }}</b-tooltip>
                            <p :id="'subtitle'+key" style="font-size: 10px">{{ spending.subtitle.substring(0, 25) }} <span v-if="spending.subtitle.length > 25">...</span></p>
                            <b-tooltip v-if="spending.subtitle.length > 25" :target="'subtitle'+key">{{ spending.subtitle }}</b-tooltip>
                            <p style="font-size: 16px; font-weight: 300;">
                                {{ spending.display_price }}
                                <img v-if="spending.eligible" src="@/assets/images/M3/M3Sketch/procentMediu.png" alt="Procent de mediu" :class="Number(spending.contribution_percentage) !== 100 ? 'gray-leaf' : ''" style="width: 13px; height: 16px; margin-left: 10px;">
                                <b-icon-x-circle-fill v-else style="color: #ff4141;"></b-icon-x-circle-fill>
                            </p>
                        </div>
                        <div class="reper-image">
                            <img :src="spending.logo" :alt="spending.subtitle">
                        </div>
                    </div>
                    <div v-if="spending.offers_watermark" class="bottom-info" @click.stop="downloadWatermark(spending)">
                        <p>DESCARCĂ OFERTELE</p>
                    </div>
                    <img v-if="spending.is_smishub" src="@/assets/images/M3/M3Sketch/hub-green.png" class="hub-green">
                </li>
            </ul>
        </b-collapse>
        <!--        <div class="ref-product-image" style="position: relative">
                    <p :id="'product'+ categoryKey" :class="{'eco-percent': true, 'non-eco': product.contribution_percentage == 0}">{{ parseInt(product.contribution_percentage) }}% <img src="@/assets/images/M3/M3Sketch/eco-icon.png" alt=""></p>
                    <b-tooltip :target="'product'+ categoryKey" triggers="hover" custom-class="customTooltip" placement="bottom">Contribuția la obiectivele de mediu</b-tooltip>
                    <b-icon-info-circle :id="'description'+ categoryKey" class="product-description"></b-icon-info-circle>
                    <b-tooltip :target="'description'+ categoryKey" triggers="hover" custom-class="wideTooltip" placement="right">{{ product.justificare }}</b-tooltip>
                    <img :src="product.logo" :alt="product.subtitle">
                </div>
                <p class="title">{{ product.title }}</p>
                <p v-if="product.is_mandatory" class="subtitle yellow">Activitate obligatorie!</p>
                <p v-else class="subtitle">{{ product.subtitle }}</p>
                <p class="price">
                    <strong>{{ product.display_price }}</strong>
                    <span v-if="product.vat_included" class="price-small"> (TVA inclus)</span>
                </p>
                <div class="button-add" @click="$emit('addProduct')">Adaugă în buget <b-icon-plus-circle-fill class="add-icon"></b-icon-plus-circle-fill></div>-->
    </div>
</template>

<script>
    import { BIconPlusCircleFill, BTooltip, BIconInfoCircle, BIconArrowRight, BIconArrowDown, BCollapse, BIconXCircleFill } from "bootstrap-vue";
    export default {
        components: {
            BIconPlusCircleFill,
            BTooltip,
            BIconInfoCircle,
            BIconArrowRight,
            BIconArrowDown,
            BCollapse,
            BIconXCircleFill
        },
        props: {
            category: null,
            categoryKey: null,
            search: null,
        },
        data() {
            return {}
        },
        watch: {
            search: {
                handler: function() {
                    if(this.search && this.search.length > 0){
                        this.category.visible = false
                    }
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            getClassBySpending(spending) {
                if(Number(spending.contribution_percentage) !== 100 && spending.eligible) {
                    return 'gray-label'
                } else if(!spending.eligible) {
                    return 'red-label'
                }
            },
            downloadWatermark(spending) {
                location.href = spending.offers_watermark;
            }
        }
    }
</script>

<style scoped>
.bottom-info{
    background: #d2d6db;
    padding: 2px 2px 2px 15px;
    position: absolute;
    bottom: 0;
    left: 6px;
    width: calc( 100% - 6px );
}
.hub-green{
    background: #fff;
    padding: 1px 10px;
    position: absolute;
    right: 0;
    bottom: 0;
    border-bottom-right-radius: 6px;
    transition: 0.3s;
    max-height: 21px;
}
.bottom-info p{
   color: #565353;
    font-size: 10px;
}
.ref-product{
    width: 100%;
}
.reper-title{
    width: 100%;
    background: #9197ab;
    font-size: 14px;
    font-weight: 600;
    color: #e7ebf1;
    padding: 10px 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: 0.3s;
}
.reper-title:hover{
    background: #848a9f;
}
.reper-title >>> svg{
    font-size: 18px;
}
.flex-repers{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}
.personal-reper{
    background: #fff;
    position: relative;
    width: 100%;
    max-width: 267px;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.3s;
    padding: 0;
    min-height: 95px;
}
.flex-reper{
    padding: 5px 5px 5px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.personal-reper:hover{
    background: #f1f1f1;
}
.personal-reper:hover .hub-green{
    background: #f1f1f1;
}
.reper-label{
    position: absolute;
    content: '';
    width: 6px;
    height: 100%;
    left: 0;
    bottom: 0;
    background: #49cda8;
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
}
.gray-label{
    background: #cdd2e3 !important;
}
.red-label{
    background: #ff4141 !important;
}
.reper-image img{
    max-width: 60px;
    max-height: 60px;
    object-fit: contain;
}
.reper-info p{
    font-size: 12px;
    color: #9197ab;
}
.reper-info .gray-leaf{
    filter: grayscale(1);
}
.ref-product-image{
    border-radius: 3px;
    border: 1px solid #4b4b4b;
    background: linear-gradient(to bottom, #232323, #3d3d3d);
    padding: 10px;
    height: 140px;
    text-align: center;
    position: relative;
}
.ref-product-image img {
    height: 100%;
    max-height: 118px;
    max-width: 160px;
    object-fit: contain;
}
.eco-percent{
    font-weight: 800;
    font-size: 14px;
    color: #9cff00;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    position: absolute;
    left: 8px;
    top: 8px;
}
.eco-percent img{
    margin-left: 7px;
}
.eco-percent.non-eco{
    opacity: 0.2;
}
.title{
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    margin-top: 5px;
}
.subtitle{
    font-weight: 200;
    color: #d0d0d0;
    font-size: 14px;
    margin-top: -3px;
    max-height: 20px;
    overflow: hidden;
    text-align: left;
}
.subtitle.yellow {
    font-weight: 700;
    color: #FFB400;
}
.price{
    text-align: left;
    font-size: 21px;
    color: #49cda8;
}
.price-small{
    font-size: 10px;
}
.button-add{
    border: 1px solid #4b4b4b;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
    color: #d0d0d0;
    justify-content: center;
    font-weight: 300;
    cursor: pointer;
    transition: 0.4s;
}
.button-add:hover{
    background: #4b4b4b;
    color: #fff;
}
.button-add svg{
    font-size: 15px;
    font-weight: 900;
    margin-left: 10px;
}
.product-description{
    position: absolute;
    right: 8px;
    top: 8px;
    color: #fff;
}
.wideTooltip >>> .tooltip-inner{
    max-width: 400px;
    padding: 4px 10px;
    font-size: 13px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.wideTooltip >>> .arrow:before{
    display: none;
}
@media (max-width: 1850px){
    .personal-reper{
        max-width: 49%;
    }
}
@media (max-width: 1710px){
    .personal-reper{
        max-width: 100%;
        width: 100%;
    }
    .flex-repers{
        flex-direction: column;
    }
}
</style>
